import React, { useState } from "react";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { API } from "../../../contexts/AuthContext";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function RoadmapContinue({ tripId, roadmap, onStarted }) {
  const [sending, setSending] = useState(false);
  if (!roadmap?.has_more && !roadmap?.extending) return null;

  if (roadmap.extending) {
    return (
      <div className="flex items-center justify-center gap-2 text-sm text-[#9A8F86] italic py-6" style={LORA} data-testid="roadmap-extending">
        <div className="w-3 h-3 border-2 border-[#C17F59] border-t-transparent rounded-full animate-spin" />
        Je prépare la suite de votre feuille de route…
      </div>
    );
  }

  const start = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/trips/${tripId}/roadmap/continue`);
      onStarted();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossible de générer la suite pour le moment.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="text-center py-6" data-testid="roadmap-continue">
      <p className="text-xs text-[#9A8F86] italic mb-3" style={LORA}>
        {roadmap.jours.length} jour{roadmap.jours.length > 1 ? "s" : ""} sur {roadmap.total_days} prêts
        {roadmap.extend_error ? " · la dernière tentative n'a pas abouti, réessayez" : ""}
      </p>
      <button onClick={start} disabled={sending} className="btn-secondary text-sm inline-flex items-center gap-2" data-testid="roadmap-continue-btn">
        <ChevronDown size={14} strokeWidth={1.5} /> Afficher le reste de la feuille de route
      </button>
    </div>
  );
}
